import { apiClient } from "./ApiClient";

const ok = () => true;

// Pull {ec2, script, ready} out of any envelope: raw object, axios {data}, or APIGW {body: string}
function normalize(payload) {
  // axios -> { data: ... }
  const data = payload?.data ?? payload;

  // API Gateway proxy -> { body: "..." }
  const raw = data?.body ?? data;

  // string body -> parse
  const obj = (typeof raw === "string") ? JSON.parse(raw) : raw;

  // finally return the shape the UI expects
  return {
    ec2:   obj?.ec2 ?? "unknown",
    script: obj?.script ?? "unknown",
    ready: !!obj?.ready,
  };
}

export const statusBehaviorAPI = async (instanceId) => {
  const res = await apiClient.post(
    "behavioranalytics",
    { action: "statusBehavior", instanceId },
    { validateStatus: ok }
  );
  return normalize(res); // <-- ALWAYS {ec2, script, ready}
};

export const startBehaviorAPI = async (instanceId) => {
  const res = await apiClient.post(
    "behavioranalytics",
    { action: "startBehavior", instanceId },
    { validateStatus: ok }
  );
  return normalize(res); // may still return "script":"starting" etc.
};

export const stopBehaviorAPI = async (instanceId) => {
  const res = await apiClient.post(
    "behavioranalytics",
    { action: "stopBehavior", instanceId },
    { validateStatus: ok }
  );
  // Some stop routes return extra fields; keep a safe normalize:
  return normalize(res);
};

export const scoreSimilarityAPI = async (instanceId, topic, text) => {
  const res = await apiClient.post(
    "behavioranalytics",
    { action: "scoreSimilarity", instanceId, topic, text },
    { validateStatus: ok }
  );
  // score route returns {score} directly; pass through:
  return (res?.data?.body)
    ? JSON.parse(res.data.body)
    : (res?.data ?? res);
};
